import { useEffect, useState } from "react";
import { TREE_COUNTER_URL } from "@util/constants";

type TreeCounterProps = {
  data: {
    icon: string;
    text: string;
    subtext: string;
  };
};

const TreeCounter = ({ data }: TreeCounterProps) => {
  const [count, setCount] = useState<string>("1,650,483");

  useEffect(() => {
    const fetchTreeCount = async () => {
      try {
        const response = await fetch(TREE_COUNTER_URL);
        if (!response.ok) return;
        const treeCountData = await response.json();
        if (treeCountData?.count != null) {
          setCount(treeCountData.count);
        }
      } catch (error) {
        console.warn("Error while fetching tree count from json file: ", error);
      }
    };

    fetchTreeCount();
  }, []);
  return (
    <div>
      <div className="trees-count lg:d-fx">
        <figure dangerouslySetInnerHTML={{ __html: data.icon }}></figure>
        <p className="ff-euclid fw-700">
          <span className="trees__count">{count}</span>
          {data.text}
        </p>
      </div>
      <p className="text-xs mt-1">{data.subtext}</p>
    </div>
  );
};

export default TreeCounter;
